export default class Elemento {
  constructor() {
    this.cod;
    this.orden;
    this.literales = new Array();
    this.id;
    this.GetLiteral = function (codIdioma) {
      var literales = this.literales.filter((literal) => literal.codIdioma == codIdioma);
      if (literales.length == 1) {
        return literales[0].texto;
      } else {
        return "[" + this.cod + "]";
      }
    };
  }
}
